// extracted by mini-css-extract-plugin
export default {"captchaWrapper":"Welcome_captchaWrapper--Dw2"};